import { memo } from 'react';
import { cn } from '@/lib/utils';
import type { IQuotedMessageProps } from '@/@types/messages';

export const QuotedMessage = memo(function QuotedMessage({
  senderName,
  text,
  isOutgoing,
}: IQuotedMessageProps) {
  return (
    <blockquote
      aria-label={senderName ? `Quoted message from ${senderName}` : 'Quoted message'}
      className={cn(
        'flex gap-2 rounded-lg px-3 py-2 mb-1 text-xs',
        isOutgoing
          ? 'bg-primary/10 border-l-2 border-l-primary'
          : 'bg-muted/80 border-l-2 border-l-accent-foreground'
      )}
    >
      <div className="min-w-0 flex-1">
        {senderName && <p className="font-semibold text-foreground truncate">{senderName}</p>}
        <p className="text-muted-foreground truncate">{text ?? 'Media'}</p>
      </div>
    </blockquote>
  );
});
